module.exports = __webpack_public_path__ + "img/1-en.87f579c7.jpg";